/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type TaskSubjectType = typeof TaskSubjectType[keyof typeof TaskSubjectType];


export const TaskSubjectType = {
  player: 'player',
  club: 'club',
  contract: 'contract',
} as const;
